/**
 * SEO 配置 - models (Español)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Generador de video IA insignia | WeryAI',
        description: 'Google Veo 3.1: Modelo de video AI insignia con audio nativo y control de fotogramas.',
        keywords: 'Google Veo 3.1, video IA insignia, generador de video IA, WeryAI',
    },
    veo_3: {
        title: 'veo 3 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast Generación de Video e Imagen IA | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 Generación de Video IA | WeryAI',
        description: 'WeryAI Video 1.0 para crear videos IA cinemáticos.',
        keywords: 'WeryAI Video 1.0, video IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 Generación de Imagen IA | WeryAI',
        description: 'WeryAI Image 2.0 para generar imágenes IA de calidad estudio.',
        keywords: 'WeryAI Image 2.0, imagen IA, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Generador de Imágenes - xAI | WeryAI',
        description: 'Experimenta Grok-2 de xAI en WeryAI.',
        keywords: 'Grok-2, xAI, imagen IA, WeryAI',
    },
    kling_ai: {
        title: 'kling ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance Generación de Video e Imagen IA | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    wan_2_6: {
        title: 'Wan 2.6 | Generador de video con IA avanzado de Alibaba | WeryAI',
        description: 'Wan 2.6 es el nuevo modelo multimodal insignia de Alibaba para generación de video con IA, con calidad cinematográfica 1080p, sincronización nativa de audio y video y capacidades inteligentes de narrativa multi-toma. Pruébalo gratis en WeryAI.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, generador de video con IA, modelo de video multimodal, texto a video, imagen a video, sincronización de audio, WeryAI Wan 2.6',
    },
    wan_ai: '',
    image_gpt_4o: {
        title: 'GPT-4o Generador de Imágenes - IA de Imagen Nativa de OpenAI | WeryAI',
        description: 'Genera imágenes con IA usando GPT-4o. Comprensión semántica potente y salida visual de alta calidad. Pruébalo gratis en WeryAI.',
        keywords: 'GPT-4o, OpenAI imagen, arte IA, generación de imágenes, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Generación de imágenes Google Gemini 3.0 Pro | WeryAI',
        description: 'Modelo de imagen IA basado en razonamiento. Calidad 4K ultra realista y tipografía perfecta.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, generación de imágenes IA, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash dibujo rápido | WeryAI',
        description: 'Generador de imágenes IA ultrarrápido de Google DeepMind. Edición con lenguaje natural.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, dibujo rápido, WeryAI',
    },
    image_flux: {
        title: 'Generador de imágenes FLUX AI - Modelo de código abierto | WeryAI',
        description: 'FLUX desarrollado por el equipo original de Stable Diffusion. Calidad visual excepcional.',
        keywords: 'FLUX, AI, generación de imágenes, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Mejora profesional de dibujo IA | WeryAI',
        description: 'FLUX.1 Pro y Max con renderizado de texto mejorado y consistencia de personajes.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Modelo de difusión texto a imagen | WeryAI',
        description: 'Genera imágenes fotorrealistas, artísticas y abstractas con Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, difusión, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Modelo de renderizado de texto de Alibaba | WeryAI',
        description: 'Modelo de imagen IA de Alibaba para renderizado de texto multilingüe.',
        keywords: 'Qwen Image, Alibaba, renderizado de texto, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Generación de imágenes - Modelo de alta fidelidad | WeryAI',
        description: 'Wan 2.5 con seguimiento preciso de prompts y renderizado fotográfico.',
        keywords: 'Wan AI, Wan 2.5, generación de imágenes, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Modelo de dibujo 4K por lotes de ByteDance | WeryAI',
        description: 'Modelo de dibujo ultrarrápido de ByteDance con procesamiento por lotes.',
        keywords: 'Seedream, ByteDance, dibujo 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Modelo de creación de imágenes IA de ByteDance | WeryAI',
        description: 'Dreamina 4.0 para conversión de boceto a imagen y transferencia de estilo.',
        keywords: 'Dreamina 4.0, ByteDance, creación de imágenes IA, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Modelo de Generación de Imágenes IA de ByteDance | WeryAI',
        description: 'Seedream 4.5 es el último modelo de imagen IA insignia de ByteDance, enfocado en renderizado preciso de tipografía y fusión de múltiples imágenes con salida 4K ultra HD. Pruébalo gratis en WeryAI.',
        keywords: 'Seedream 4.5, generación de imágenes IA, renderizado tipográfico, fusión de imágenes, ByteDance, calidad 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Generación de imágenes flexible, detallada y vibrante | WeryAI',
        description: 'Midjourney es un modelo de imagen IA insignia de un laboratorio de investigación independiente, reconocido por su estética artística. Pruébalo gratis en WeryAI.',
        keywords: 'Midjourney, generación de imágenes IA, creación artística, calidad de iluminación, renderizado de texto, retratos hiperrealistas, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generador de Video IA - Crea Videos Cinematográficos | WeryAI',
        description: 'Crea videos impresionantes con Runway Gen-4.5 en WeryAI. Arquitectura híbrida autorregresiva-difusión para simulación física precisa y consistencia temporal.',
        keywords: 'Runway Gen-4.5, generador de video IA, video IA cinematográfico, simulación física, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generador de Video IA - Creación de Video de Alta Calidad | WeryAI',
        description: 'Genera videos de alta calidad con Kling 2.6 Pro en WeryAI. Generación audiovisual nativa, calidad cinematográfica 1080p, excelente adherencia a prompts.',
        keywords: 'Kling 2.6 Pro, generador de video IA, video IA de alta calidad, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generador de Video - Control de cámara preciso y guía de fotogramas | WeryAI',
        description: 'Genera videos IA cinematográficos con Dreamina 3.0 (Jimeng 3.0) en WeryAI. Control preciso de fotogramas inicio/fin, movimientos de cámara profesionales y generación de video 1080p de alto dinamismo.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generador de video IA, control de cámara, fotogramas inicio fin, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generador de Video IA - Generación de Video Creativa | WeryAI',
        description: 'Libera tu creatividad en WeryAI con el generador de video IA Kling O1. Perfecto para generar contenido de video imaginativo y único.',
        keywords: 'Kling O1, generador de video IA, video IA creativo, Kling AI, WeryAI',
    },
}
